/**
 * @generated SignedSource<<c2dfae9765b3bc0ce6ada3a731407244>>
 * @relayHash 806320bf651e1a970f6ae95433113bea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad277b3a81f2e5e7e38d1dadbf548a2e7a3059036f7e773226350ba79199b7e6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useStaticContextOperationsQuery$variables = Record<PropertyKey, never>;
export type useStaticContextOperationsQuery$data = {
  readonly siteOperations: {
    readonly application: ReadonlyArray<string | null | undefined>;
    readonly userProfile: ReadonlyArray<string | null | undefined>;
  } | null | undefined;
};
export type useStaticContextOperationsQuery = {
  response: useStaticContextOperationsQuery$data;
  variables: useStaticContextOperationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SiteOperations",
    "kind": "LinkedField",
    "name": "siteOperations",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "userProfile"
      },
      {
        "kind": "ScalarField",
        "name": "application"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useStaticContextOperationsQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useStaticContextOperationsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "806320bf651e1a970f6ae95433113bea",
    "id": "ad277b3a81f2e5e7e38d1dadbf548a2e7a3059036f7e773226350ba79199b7e6",
    "metadata": {},
    "name": "useStaticContextOperationsQuery",
    "operationKind": "query",
    "text": "query useStaticContextOperationsQuery{siteOperations{userProfile,application}}"
  }
};
})();

(node as any).hash = "cfbc81f664df00ae184a724ab64a4ad0";

export default node;
